<template>
  <div>
    <el-tabs v-model="activePane" @tab-click="onTabChange">
      <el-tab-pane name="P">
        <span slot="label">Pending</span>
      </el-tab-pane>
      <el-tab-pane name="D">
        <span slot="label">Fulfilled</span>
      </el-tab-pane>
    </el-tabs>
    <div class="card shadow">
      <div class="card-header">
        Orders
      </div>
      <div v-loading="loading">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th>Order Reference</th>
              <th>User</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" :key="order.id">
              <td>
                <router-link :to="{ name: 'orders-id', params: { id: order.id } }">
                  {{ order.reference_id }}
                </router-link>
                <span v-if="order.status === 'E'" class="badge badge-danger">Error</span>
              </td>
              <td>
                <div v-if="order.user">
                  <router-link :to="{ name: 'users-id', params: { id: order.user.id }}">
                    {{ order.user.name }}
                  </router-link>
                  <div class="text-muted">@{{ order.user.username }}</div>
                </div>
                <div v-else>
                  {{ order.email }}
                </div>
              </td>
              <td>{{ order.createdAt }}</td>
            </tr>
            <tr v-if="!orders.length">
              <td class="text-muted" colspan="3">No orders were found.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      loading: true,
      activePane: 'P',
      orders: [],
    }
  },

  async mounted() {
    await this.getOrders()
  },

  methods: {
    onTabChange(tab, event) {
      this.activePane = tab.name
      this.getOrders()
    },
    async getOrders() {
      try {
        this.loading = true

        var { data } = await this.$http.get(`/orders`, {
          params: {
            all: true,
            status: this.activePane,
          },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.orders = data.map(item => {
        item.createdAt = moment(item.createdAt).fromNow()
        return item
      })
    },
  },
}
</script>

<style>

</style>
